import React, { useState } from "react";
import InputField from "../technologyModal/InputFields/InputField";
import MainService from "../../common/MainService";
import { NotificationManager } from "react-notifications";
import { useHistory } from "react-router-dom";

const SIPartnerRegistrationForm = () => {
  const history = useHistory();

  const [fieldValue, setFieldValue] = useState({
    // Organisation
    partner: "",
    orgName: "",
    // Ecosystem
    domainType: "",
    domainName: "",
    description: "",
    // Infrastructure
    plan: "",
    deploymentType: "",
    // ENO Account
    username: "",
    realm: "",
    email: "",
    phone: "",
    // Confirmation
    consent: false,
  });

  const [validations, setValidations] = useState({
    partner: "",
    orgName: "",
    domainType: "",
    domainName: "",
    plan: "",
    deploymentType: "",
    username: "",
    email: "",
    phone: "",
    consent: "",
  });

  const validateAll = () => {
    const validationMessages = {
      partner: "",
      orgName: "",
      domainType: "",
      domainName: "",
      plan: "",
      deploymentType: "",
      username: "",
      email: "",
      phone: "",
      consent: "",
    };
    let isValid = true;

    if (!fieldValue.partner) {
      validationMessages.partner = "Please select the organisation type";
      isValid = false;
    }

    if (!fieldValue.orgName) {
      validationMessages.orgName = "Organisation name is required";
      isValid = false;
    }

    if (!fieldValue.domainType) {
      validationMessages.domainType = "Please select the ecosystem domain";
      isValid = false;
    }

    if (!fieldValue.domainName) {
      validationMessages.domainName = "Ecosystem network name is required";
      isValid = false;
    }

    if (!fieldValue.plan) {
      validationMessages.plan = "Please select the network size";
      isValid = false;
    }

    if (!fieldValue.deploymentType) {
      validationMessages.deploymentType = "Please select the MDC deployment model";
      isValid = false;
    }

    if (!fieldValue.username) {
      validationMessages.username = "Network ID / Username is required";
      isValid = false;
    }

    if (!fieldValue.email) {
      validationMessages.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(fieldValue.email)) {
      validationMessages.email = "Email format must be as example@mail.com";
      isValid = false;
    }

    if (!fieldValue.phone) {
      validationMessages.phone = "Phone number is required";
      isValid = false;
    }

    if (!fieldValue.consent) {
      validationMessages.consent = "You must agree to the terms";
      isValid = false;
    }

    if (!isValid) {
      setValidations(validationMessages);
    }

    return isValid;
  };

  const validateOne = (e) => {
    const { name } = e.target;
    const value = fieldValue[name];
    let message = "";

    if (!value && name === "partner") {
      message = "Please select the organisation type";
    }
    if (!value && name === "orgName") {
      message = "Organisation name is required";
    }
    if (!value && name === "domainType") {
      message = "Please select the ecosystem domain";
    }
    if (!value && name === "domainName") {
      message = "Ecosystem network name is required";
    }
    if (!value && name === "plan") {
      message = "Please select the network size";
    }
    if (!value && name === "deploymentType") {
      message = "Please select the MDC deployment model";
    }
    if (!value && name === "username") {
      message = "Network ID / Username is required";
    }
    if (!value && name === "email") {
      message = "Email is required";
    }
    if (value && name === "email" && !/\S+@\S+\.\S+/.test(value)) {
      message = "Please enter a valid email";
    }
    if (!value && name === "phone") {
      message = "Phone number is required";
    }

    setValidations({ ...validations, [name]: message });
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const fieldVal = type === "checkbox" ? checked : value;

    setFieldValue((prevVal) => {
      const updated = { ...prevVal, [name]: fieldVal };
      // Realm is always taken from the Network ID / Username
      if (name === "username") {
        updated.realm = fieldVal;
      }
      return updated;
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const isValid = validateAll();

    if (!isValid) {
      return false;
    }

    const data = {
      source: fieldValue.email,
      networkid: fieldValue.email,
      partnername: fieldValue.username,
      destination: `${window.appConfig.TokenRelam}`,
      usertype: "Consumer",
      domain: `${window.appConfig.TokenRelam}`,
      password: "",
      domainname: "",
      domaintype: "",
      cloudgateway: "",
      plantype: "",
      cardnumber: "",
      cardname: "",
      date: "",
      address: "",
      phone: fieldValue.phone,
      email: fieldValue.email,
      requesttype: "partnerRequest",
      username: fieldValue.username,
      json: {
        partnerType: fieldValue.partner,
        orgName: fieldValue.orgName,
        username: fieldValue.username,
        realm: fieldValue.realm,
        domainType: fieldValue.domainType,
        domainName: fieldValue.domainName,
        description: fieldValue.description,
        phone: fieldValue.phone,
        email: fieldValue.email,
        deploymentType: fieldValue.deploymentType,
        plan: fieldValue.plan,
        consent: fieldValue.consent,
      },
    };

    MainService.sendRequest(data).then(() => {
      setTimeout(() => {
        history.push("/");
      }, 1000);
      return NotificationManager.success(
        "Request Sent. We will get back to you soon"
      );
    });
  };

  return (
    <>
      <form onSubmit={handleFormSubmit}>
        <div className="si-form-body">
          <h2 className="si-form-title">Tell Us About the Ecosystem You Want to Operate</h2>

          {/* ---------------- Organisation ---------------- */}
          <fieldset className="si-fieldset">
            <legend className="si-legend">Organisation</legend>

            <div className="input-container si-field">
              <label className="si-label">Organisation Type *</label>
              <select
                name="partner"
                value={fieldValue.partner}
                onChange={handleInputChange}
                onBlur={validateOne}
                className="form-control"
              >
                <option value="">What type of organisation are you? </option>
                <option value="Consumer">Agrifood Enterprise</option>
                <option value="CBBO-ENO">CBBO / NGO / Non-Profit Organisation</option>
                <option value="FPO-Federation">FPO Federation</option>
                <option value="Cooperative">Cooperative</option>
                <option value="GBR-SystemIntegrator">Sustainability / Climate Organisation</option>
                <option value="Government-Public">Government / Public Organisation</option>
                <option value="VerticalCertifiedConsultant">Advisory / Agribusiness Services</option>
                <option value="DeviceMaker-ENO">Technology / Solution Provider</option>
                <option value="Consumer-ENO">Other</option>
              </select>
              <span className="si-error" aria-live="polite">{validations.partner}</span>
            </div>

            <div className="input-container si-field">
              <label className="si-label">Organisation Name *</label>
              <InputField
                type="text"
                name="orgName"
                value={fieldValue.orgName}
                onChange={handleInputChange}
                onBlur={validateOne}
                placeholder="Please enter your organisation name"
                required="true"
              />
              <span className="si-error" aria-live="polite">{validations.orgName}</span>
            </div>
          </fieldset>

          {/* ---------------- Ecosystem ---------------- */}
          <fieldset className="si-fieldset">
            <legend className="si-legend">Ecosystem</legend>

            <div className="input-container si-field">
              <label className="si-label">Ecosystem Domain *</label>
              <select
                name="domainType"
                value={fieldValue.domainType}
                onChange={handleInputChange}
                onBlur={validateOne}
                className="form-control"
              >
                <option value="">Select the primary domain of your ecosystem </option>
                <option value="Consumer">Agriculture</option>
                <option value="GBR-SystemIntegrator">Animal & Livestock</option>
                <option value="Insects">Insects</option>
                <option value="VerticalCertifiedConsultant">Aquaculture</option>
                <option value="Food-Processing">Food & Processing</option>
                <option value="Other">Other</option>
              </select>
              <span className="si-error" aria-live="polite">{validations.domainType}</span>
            </div>

            <div className="input-container si-field">
              <label className="si-label">Ecosystem Network Name *</label>
              <InputField
                type="text"
                name="domainName"
                value={fieldValue.domainName}
                onChange={handleInputChange}
                onBlur={validateOne}
                placeholder="Please enter your ecosystem network name"
                required="true"
              />
              <span className="si-error" aria-live="polite">{validations.domainName}</span>
            </div>

            <div className="input-container si-field">
              <label className="si-label" htmlFor="description">
                Ecosystem Description
              </label>
              <textarea
                id="description"
                name="description"
                value={fieldValue.description}
                onChange={handleInputChange}
                onBlur={validateOne}
                placeholder="Briefly describe the ecosystem you want to build and operate."
                rows={4}
              />
            </div>
          </fieldset>

          {/* ---------------- Infrastructure ---------------- */}
          <fieldset className="si-fieldset">
            <legend className="si-legend">Infrastructure</legend>

            <div className="input-container si-field">
              <label className="si-label">Network Size *</label>
              <select
                name="plan"
                value={fieldValue.plan}
                onChange={handleInputChange}
                onBlur={validateOne}
                className="form-control"
              >
                <option value="">Select based on the expected number of ecosystem participants </option>
                <option value="Nano">Nano — Up to 50</option>
                <option value="Micro">Micro — 50–100</option>
                <option value="Small">Small — 100–500</option>
                <option value="Medium">Medium — 500–1,000</option>
                <option value="Large">Large — 1,000–5,000</option>
                <option value="XLarge">XLarge — 5,000+</option>
              </select>
              <span className="si-error" aria-live="polite">{validations.plan}</span>
            </div>

            <div className="input-container si-field">
              <label className="si-label">MDC Deployment *</label>
              <select
                name="deploymentType"
                value={fieldValue.deploymentType}
                onChange={handleInputChange}
                onBlur={validateOne}
                className="form-control"
              >
                <option value="">Every ENO requires at least one MDC. Select your deployment model. </option>
                <option value="Nano">Shared MDC</option>
                <option value="Micro">Dedicated MDC</option>
              </select>
              <span className="si-error" aria-live="polite">{validations.deploymentType}</span>
            </div>
          </fieldset>

          {/* ---------------- ENO Account ---------------- */}
          <fieldset className="si-fieldset">
            <legend className="si-legend">ENO Account</legend>

            <div className="input-container si-field">
              <label className="si-label">Network ID / Username *</label>
              <InputField
                type="text"
                name="username"
                value={fieldValue.username}
                onChange={handleInputChange}
                onBlur={validateOne}
                placeholder="Please enter your network ID"
                required="true"
              />
              <small className="si-hint">
                Your Network ID will be used as your ENO username and Realm.
              </small>
              <span className="si-error" aria-live="polite">{validations.username}</span>
            </div>

            <div className="input-container si-field">
              <label className="si-label">Realm</label>
              <input
                type="text"
                name="realm"
                value={fieldValue.realm}
                readOnly
                className="form-control"
              />
              <small className="si-hint">
                Automatically assigned from your Network ID.
              </small>
            </div>

            <div className="input-container si-field">
              <label className="si-label">Email *</label>
              <InputField
                type="text"
                name="email"
                value={fieldValue.email}
                onChange={handleInputChange}
                onBlur={validateOne}
                placeholder="Please enter email"
                required="true"
              />
              <span className="si-error" aria-live="polite">{validations.email}</span>
            </div>

            <div className="input-container si-field">
              <label className="si-label">Phone Number *</label>
              <InputField
                type="number"
                name="phone"
                value={fieldValue.phone}
                onChange={handleInputChange}
                onBlur={validateOne}
                placeholder="Please enter phone number"
                required="true"
              />
              <span className="si-error" aria-live="polite">{validations.phone}</span>
            </div>
          </fieldset>

          {/* ---------------- Confirmation ---------------- */}
          <fieldset className="si-fieldset">
            <legend className="si-legend">Confirmation</legend>

            <div className="input-container si-field">
              <label className="si-consent">
                <input
                  type="checkbox"
                  name="consent"
                  checked={fieldValue.consent}
                  onChange={handleInputChange}
                  className="custom-checkbox"
                />
                I agree to the Terms & Conditions *
              </label>
              <span className="si-error" aria-live="polite">{validations.consent}</span>
            </div>
          </fieldset>
        </div>

        <button className="Formbutton si-submit" type="submit">
          Create My Ecosystem Network
        </button>
      </form>
    </>
  );
};

export default SIPartnerRegistrationForm;
